import {
  Box,
  Button,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
} from '@chakra-ui/react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Icon } from '$/components/common/Icon';
import { TrackedSection } from '$/components/common/TrackedSection';
import { useAuthorization } from '$/components/core/Authentication/hooks/useAuthorization';
import { useAuthenticationStore } from '$/components/core/Authentication/stores/useAuthenticationStore';
import { DeleteAccountModal } from '$/components/core/Profile/DeleteAccountModal';
import { trackContentImpression } from '$/logger';
import { signOut } from '$/services/usecases/authentication';

export const AccountButton = () => {
  const { t } = useTranslation();

  const { hasPermission } = useAuthorization();

  const user = useAuthenticationStore.useUser();
  const onOpenAuthenticationModal = useAuthenticationStore.useOnModalOpen();
  const [isDeleteAccountModalOpen, setDeleteAccountModalOpen] = useState(false);

  const handleMenuOpen = () => {
    trackContentImpression('CloudAccount', 'Account', 'Open');
  };

  if (!hasPermission('General_User_Profile')) {
    return (
      <Button
        h='auto'
        px={{ base: '2', sm: '10' }}
        fontSize='sm'
        borderRadius='0'
        onClick={() => onOpenAuthenticationModal('register')}
        rightIcon={
          <Icon icon='account' w='6' h='6' mr={{ base: '0.5rem', sm: '0' }} />
        }
        variant='black'
      >
        <Box display={{ base: 'none', sm: 'inline-block' }}>
          {t('dashboard.header.createAccount')}
        </Box>
      </Button>
    );
  }

  return (
    <>
      <Menu onOpen={handleMenuOpen}>
        <MenuButton
          as={Button}
          h='auto'
          fontSize='sm'
          borderRadius='0'
          rightIcon={<Icon icon='account' boxSize='6' />}
          variant={hasPermission('Admin_Access') ? 'primary' : 'ghost'}
        >
          {user?.firstName}
        </MenuButton>
        <MenuList fontSize='sm' border='1px' borderColor='border'>
          <TrackedSection
            contentInteraction='ClickButton'
            contentName='CloudAccount'
            contentPiece='Account'
            contentTarget='Manage'
          >
            <MenuItem
              as='a'
              href={import.meta.env.VITE_SAPCX_PROFILE_MANAGEMENT_URL}
            >
              {t('dashboard.header.manageAccount')}
            </MenuItem>
          </TrackedSection>
          <TrackedSection
          // contentInteraction='ClickButton'
          // contentName='CloudAccount'
          // contentPiece='Account'
          // contentTarget='Manage'
          >
            <MenuItem onClick={() => setDeleteAccountModalOpen(true)}>
              {t('dashboard.authentication.profile.deleteAccount')}
            </MenuItem>
          </TrackedSection>
          <TrackedSection
            contentInteraction='ClickButton'
            contentName='CloudAccount'
            contentPiece='Account'
            contentTarget='Logout'
          >
            <MenuItem onClick={signOut}>
              {t('dashboard.header.signOut')}
            </MenuItem>
          </TrackedSection>
        </MenuList>
      </Menu>
      <DeleteAccountModal
        isOpen={isDeleteAccountModalOpen}
        onClose={() => setDeleteAccountModalOpen(false)}
      />
    </>
  );
};
